
import { Component, Mixins, Watch } from 'vue-property-decorator';
import EditableItem from '~/components/RemoteFeatureFlags/Flags/EditableItem.vue';
import EditionButtons from '~/components/RemoteFeatureFlags/Flags/EditionButtons.vue';
import ReleaseButtons from '~/components/RemoteFeatureFlags/Flags/ReleaseButtons.vue';
import { LocalUserFlag, UserFlag } from '~/interfaces/user.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        EditableItem,
        EditionButtons,
        ReleaseButtons
    }
})
export default class RemoteFeatureFlagsList extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {
    localFeatureFlags: LocalUserFlag[] = [];

    @Watch('featureFlags', { deep: true, immediate: true })
    handler(featureFlags: UserFlag[]) {
        this.localFeatureFlags = featureFlags.map(this.defaultLocalFlagValue);
    }

    defaultLocalFlagValue(flag: UserFlag): LocalUserFlag {
        return {
            ...flag,
            expire_at: new Date(flag.expire_at).toISOString().substr(0, 10),
            isValid: false,
            isEditable: false
        };
    }

    updateFlagValue(id: string, key: string, value: string | boolean) {
        const flagIndex = this.localFeatureFlags.findIndex((flag) => flag.id === id);
        if (flagIndex !== -1) {
            (this.localFeatureFlags[flagIndex] as any)[key] = value;
        }
    }

    clearEdition(id: string) {
        const localFlag = this.localFeatureFlags.find((flag) => flag.id === id);
        const flag = this.featureFlags.find((flag) => flag.id === id);

        if (localFlag && flag) {
            const defaultFlag = this.defaultLocalFlagValue(flag);
            localFlag.description = defaultFlag.description;
            localFlag.expire_at = defaultFlag.expire_at;
            localFlag.isValid = defaultFlag.isValid;
            localFlag.isEditable = defaultFlag.isEditable;
        }
    }

    async updateFlag(flag: LocalUserFlag) {
        try {
            await RemoteFeatureFlagsModule.updateFlag({ name: flag.name, flag_id: flag.id, description: flag.description, expire_at: flag.expire_at });
            this.updateFlagValue(flag.id, 'isEditable', false);
        } catch (error) {
            console.error('Error while updating the feature flag', error);
            throw error;
        }
    }

    async releaseFlag(flag: LocalUserFlag, value: boolean) {
        try {
            await RemoteFeatureFlagsModule.releaseFlag({ flag_id: flag.id, released: value });
            this.updateFlagValue(flag.id, 'released', value);
        } catch (error) {
            console.error('Error while updating the feature flag', error);
        }
    }

    async deleteFlag(id: string) {
        if (confirm('Are you sure you want to delete this feature flag? This action cannot be undone.')) {
            try {
                await RemoteFeatureFlagsModule.deleteFlag(id);
                this.localFeatureFlags = this.localFeatureFlags.filter((flag) => flag.id !== id);
            } catch (error) {
                console.error('Error while deleting the feature flag', error);
            }
        }
    }

    get featureFlags() {
        return RemoteFeatureFlagsModule.availableFlags;
    }

}
